export default Object.freeze({
  BASE_ENV: process.env.NODE_ENV,
  BASE_SERVICE_URL:
    process.env.NODE_ENV === 'production'
      ? process.env.VUE_APP_SEVICE_URL + ''
      : process.env.VUE_APP_SEVICE_URL,
  BASE_API_URL:
    process.env.NODE_ENV === 'production'
      ? process.env.VUE_APP_API_SERVER + ''
      : process.env.VUE_APP_API_SERVER,
  BASE_ASSETS_URL:
    process.env.NODE_ENV === 'production'
      ? process.env.VUE_APP_API_ASSETS
      : process.env.VUE_APP_API_ASSETS,
  BASE_API_HEADER_KEY: 'mfj-manage-token',
  BASE_API_USER_HEADER_KEY: 'mfj-user-token',

  REQUIRE_TYPE_LIST: [
    {
      label: '必須ではない',
      key: '0'
    },
    {
      label: '必須',
      key: '1'
    }
  ],
  DISCOUNT_TYPE: {
    1: {
      label: '割引',
      key: '1'
    },
    2: {
      label: '値引',
      key: '2'
    }
  },
  BASIC_STAT_LIST: [
    // 0: {
    //     value: 0,
    //     label: '非表示'
    // },
    {
      value: 1,
      label: '表示'
    },
    {
      value: 9,
      label: '削除済'
    }
  ],
  EVENT_CD_LIST: [
    {
      label: 'ロードレース',
      key: '01'
    },
    {
      label: 'ミニロード',
      key: '05'
    },
    {
      label: 'ミニバイク',
      key: '06'
    },
    {
      label: 'モトクロス',
      key: '11'
    },
    {
      label: 'トライアル',
      key: '21'
    },
    {
      label: 'スノーモビル',
      key: '31'
    },
    {
      label: 'エンデューロ',
      key: '41'
    },
    {
      label: 'スーパーモト',
      key: '86'
    },
    {
      label: 'ドラッグレース',
      key: '51'
    },
    {
      label: 'ダートトラック',
      key: '80'
    }
  ],
  LICENSE_CD_LIST: [
    {
      label: 'ジュニア',
      key: '11',
      groups: ['01', '05', '06']
    },
    {
      label: 'フレッシュマン',
      key: '12',
      groups: ['01', '05', '06']
    },
    {
      label: '国内',
      key: '13',
      groups: ['01', '05', '06']
    },
    {
      label: '国際',
      key: '16',
      groups: ['01', '05', '06']
    },
    {
      label: 'その他MFJライセンス',
      key: 'OT',
      groups: ['06']
    },
    {
      label: 'PC',
      key: '20',
      groups: ['11']
    },
    {
      label: 'ジュニア',
      key: '21',
      groups: ['11']
    },
    {
      label: '国内B',
      key: '23',
      groups: ['11']
    },
    {
      label: '国内A',
      key: '24',
      groups: ['11']
    },
    {
      label: '国際B',
      key: '25',
      groups: ['11']
    },
    {
      label: '国際A',
      key: '26',
      groups: ['11']
    },
    {
      label: 'その他MFJライセンス',
      key: 'OT',
      groups: ['11']
    },
    {
      label: 'ジュニア',
      key: '31',
      groups: ['21']
    },
    {
      label: '国内B',
      key: '33',
      groups: ['21']
    },
    {
      label: '国内A',
      key: '34',
      groups: ['21']
    },
    {
      label: '国際B',
      key: '35',
      groups: ['21']
    },
    {
      label: '国際A',
      key: '36',
      groups: ['21']
    },
    {
      label: 'その他MFJライセンス',
      key: 'OT',
      groups: ['21']
    }
  ],
  AREA_CD_LIST: [
    {
      label: '北海道',
      key: 1
    },
    {
      label: '東北',
      key: 2
    },
    {
      label: '関東',
      key: 3
    },
    {
      label: '中部',
      key: 4
    },
    {
      label: '近畿',
      key: 5
    },
    {
      label: '中国',
      key: 6
    },
    {
      label: '四国',
      key: 7
    },
    {
      label: '九州',
      key: 8
    }
  ],
  PREF_CD_LIST: [
    {
      label: '北海道',
      key: '1',
      group: 1
    },
    {
      label: '青森県',
      key: '2',
      group: 2
    },
    {
      label: '岩手県',
      key: '3',
      group: 2
    },
    {
      label: '宮城県',
      key: '4',
      group: 2
    },
    {
      label: '秋田県',
      key: '5',
      group: 2
    },
    {
      label: '山形県',
      key: '6',
      group: 2
    },
    {
      label: '福島県',
      key: '7',
      group: 2
    },
    {
      label: '茨城県',
      key: '8',
      group: 3
    },
    {
      label: '栃木県',
      key: '9',
      group: 3
    },
    {
      label: '群馬県',
      key: '10',
      group: 3
    },
    {
      label: '埼玉県',
      key: '11',
      group: 3
    },
    {
      label: '千葉県',
      key: '12',
      group: 3
    },
    {
      label: '東京都',
      key: '13',
      group: 3
    },
    {
      label: '神奈川県',
      key: '14',
      group: 3
    },
    {
      label: '新潟県',
      key: '15',
      group: 4
    },
    {
      label: '富山県',
      key: '16',
      group: 4
    },
    {
      label: '石川県',
      key: '17',
      group: 4
    },
    {
      label: '福井県',
      key: '18',
      group: 4
    },
    {
      label: '山梨県',
      key: '19',
      group: 4
    },
    {
      label: '長野県',
      key: '20',
      group: 4
    },
    {
      label: '岐阜県',
      key: '21',
      group: 4
    },
    {
      label: '静岡県',
      key: '22',
      group: 4
    },
    {
      label: '愛知県',
      key: '23',
      group: 4
    },
    {
      label: '三重県',
      key: '24',
      group: 5
    },
    {
      label: '滋賀県',
      key: '25',
      group: 5
    },
    {
      label: '京都府',
      key: '26',
      group: 5
    },
    {
      label: '大阪府',
      key: '27',
      group: 5
    },
    {
      label: '兵庫県',
      key: '28',
      group: 5
    },
    {
      label: '奈良県',
      key: '29',
      group: 5
    },
    {
      label: '和歌山県',
      key: '30',
      group: 5
    },
    {
      label: '鳥取県',
      key: '31',
      group: 6
    },
    {
      label: '島根県',
      key: '32',
      group: 6
    },
    {
      label: '岡山県',
      key: '33',
      group: 6
    },
    {
      label: '広島県',
      key: '34',
      group: 6
    },
    {
      label: '山口県',
      key: '35',
      group: 6
    },
    {
      label: '徳島県',
      key: '36',
      group: 7
    },
    {
      label: '香川県',
      key: '37',
      group: 7
    },
    {
      label: '愛媛県',
      key: '38',
      group: 7
    },
    {
      label: '高知県',
      key: '39',
      group: 7
    },
    {
      label: '福岡県',
      key: '40',
      group: 7
    },
    {
      label: '佐賀県',
      key: '41',
      group: 8
    },
    {
      label: '長崎県',
      key: '42',
      group: 8
    },
    {
      label: '熊本県',
      key: '43',
      group: 8
    },
    {
      label: '大分県',
      key: '44',
      group: 8
    },
    {
      label: '宮崎県',
      key: '45',
      group: 8
    },
    {
      label: '鹿児島県',
      key: '46',
      group: 8
    },
    {
      label: '沖縄県',
      key: '47',
      group: 8
    }
  ]

  // "1": {
  //     "label": "北海道",
  //     "key": "01"
  // },
  // "2": {
  //     "label": "青森県",
  //     "key": "02"
  // },
  // "3": {
  //     "label": "岩手県",
  //     "key": "03"
  // },
  // "4": {
  //     "label": "宮城県",
  //     "key": "04"
  // },
  // "5": {
  //     "label": "秋田県",
  //     "key": "05"
  // },
  // "6": {
  //     "label": "山形県",
  //     "key": "06"
  // },
  // "7": {
  //     "label": "福島県",
  //     "key": "07"
  // },
  // "8": {
  //     "label": "茨城県",
  //     "key": "08"
  // },
  // "9": {
  //     "label": "栃木県",
  //     "key": "09"
  // },
  // "10": {
  //     "label": "群馬県",
  //     "key": "10"
  // },
  // "11": {
  //     "label": "埼玉県",
  //     "key": "11"
  // },
  // "12": {
  //     "label": "千葉県",
  //     "key": "12"
  // },
  // "13": {
  //     "label": "東京都",
  //     "key": "13"
  // },
  // "14": {
  //     "label": "神奈川県",
  //     "key": "14"
  // },
  // "15": {
  //     "label": "新潟県",
  //     "key": "15"
  // },
  // "16": {
  //     "label": "富山県",
  //     "key": "16"
  // },
  // "17": {
  //     "label": "石川県",
  //     "key": "17"
  // },
  // "18": {
  //     "label": "福井県",
  //     "key": "18"
  // },
  // "19": {
  //     "label": "山梨県",
  //     "key": "19"
  // },
  // "20": {
  //     "label": "長野県",
  //     "key": "20"
  // },
  // "21": {
  //     "label": "岐阜県",
  //     "key": "21"
  // },
  // "22": {
  //     "label": "静岡県",
  //     "key": "22"
  // },
  // "23": {
  //     "label": "愛知県",
  //     "key": "23"
  // },
  // "24": {
  //     "label": "三重県",
  //     "key": "24"
  // },
  // "25": {
  //     "label": "滋賀県",
  //     "key": "25"
  // },
  // "26": {
  //     "label": "京都府",
  //     "key": "26"
  // },
  // "27": {
  //     "label": "大阪府",
  //     "key": "27"
  // },
  // "28": {
  //     "label": "兵庫県",
  //     "key": "28"
  // },
  // "29": {
  //     "label": "奈良県",
  //     "key": "29"
  // },
  // "30": {
  //     "label": "和歌山県",
  //     "key": "30"
  // },
  // "31": {
  //     "label": "鳥取県",
  //     "key": "31"
  // },
  // "32": {
  //     "label": "島根県",
  //     "key": "32"
  // },
  // "33": {
  //     "label": "岡山県",
  //     "key": "33"
  // },
  // "34": {
  //     "label": "広島県",
  //     "key": "34"
  // },
  // "35": {
  //     "label": "山口県",
  //     "key": "35"
  // },
  // "36": {
  //     "label": "徳島県",
  //     "key": "36"
  // },
  // "37": {
  //     "label": "香川県",
  //     "key": "37"
  // },
  // "38": {
  //     "label": "愛媛県",
  //     "key": "38"
  // },
  // "39": {
  //     "label": "高知県",
  //     "key": "39"
  // },
  // "40": {
  //     "label": "福岡県",
  //     "key": "40"
  // },
  // "41": {
  //     "label": "佐賀県",
  //     "key": "41"
  // },
  // "42": {
  //     "label": "長崎県",
  //     "key": "42"
  // },
  // "43": {
  //     "label": "熊本県",
  //     "key": "43"
  // },
  // "44": {
  //     "label": "大分県",
  //     "key": "44"
  // },
  // "45": {
  //     "label": "宮崎県",
  //     "key": "45"
  // },
  // "46": {
  //     "label": "鹿児島県",
  //     "key": "46"
  // },
  // "47": {
  //     "label": "沖縄県",
  //     "key": "47"
  // }
  // }
})
